// extracted by mini-css-extract-plugin
export default {"participantBackground":"ParticipantsListElement_participantBackground__JfwVv","participantName":"ParticipantsListElement_participantName__05gZe"};